import { render, staticRenderFns } from "./ModalDialogGetTokenGloFAS.vue?vue&type=template&id=4c8addfe&scoped=true&"
import script from "./ModalDialogGetTokenGloFAS.vue?vue&type=script&lang=js&"
export * from "./ModalDialogGetTokenGloFAS.vue?vue&type=script&lang=js&"
import style0 from "./ModalDialogGetTokenGloFAS.vue?vue&type=style&index=0&id=4c8addfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8addfe",
  null
  
)

export default component.exports